module.exports = __webpack_public_path__ + "img/Car.f5983d18.svg";